import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-approvals',
  templateUrl: './approvals.component.html',
  styleUrls: ['./approvals.component.scss']
})
export class ApprovalsComponent {}
